// src/components/Footer.tsx
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  padding: 28px 18px;
  // background: linear-gradient(145deg, #eff4f9, #dfe7f0);
  // border-top: 1px solid #cfd9e4;
  //color: #4a5a6b;
`;

const FooterInner = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  display: grid;
  gap: 10px;
  text-align: center;
`;

const InlineList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 14px;

  a {
    color: #1f2b3a;
    text-decoration: none;

    &:hover {
      color: #0f1c2d;
    }
  }
`;

const Dot = styled.span`
  color: #9aa8b6;
`;

const Footer: React.FC = () => (
  <FooterContainer>
    <FooterInner>
      <InlineList>
        <span>(c) {new Date().getFullYear()} Chots AI</span>
      </InlineList>
      <InlineList>
        <Link to="/products/chot-buddies">Chot Buddies</Link>
        <Dot>|</Dot>
        <Link to="/contact-us/">Contact Us</Link>
      </InlineList>
      {/* <InlineList>
        <span>Android</span>
        <Dot>|</Dot>
        <span>iOS (coming soon)</span>
        <Dot>|</Dot>
        <span>Web (planned)</span>
      </InlineList> */}
    </FooterInner>
  </FooterContainer>
);

export default Footer;
